import React from 'react';
import AnnouncementsSection from '../../components/AnnouncementsSection';

export const socialLinks = [
  { name: 'DISCORD', label: 'Centrum społeczności', href: 'https://discord.gg/Uxnr8GyjkK', icon: 'forum' },
  { name: 'INSTAGRAM', label: 'Kadry z trasy', href: 'https://www.instagram.com/app.vroom/', icon: 'photo_camera' },
  { name: 'TIKTOK', label: 'VROOM w ruchu', href: 'https://www.tiktok.com/@vroom.app1', icon: 'music_note' },
  { name: 'YOUTUBE', label: 'Filmy i premiery', href: 'https://www.youtube.com/@V-ROOMAPP', icon: 'smart_display' },
];

export default function CommunityGrid() {
  return (
    <section className="dl-community">
      <div className="dl-announcements-wrap">
        <AnnouncementsSection />
      </div>
      <div className="dl-section-heading dl-reveal">
        <div className="dl-section-code">04 / COMMUNITY</div>
        <h2>Technologia łączy.<br /><em>Ludzie napędzają.</em></h2>
      </div>
      <div className="dl-bento">
        <article className="dl-bento-card dl-bento-main dl-reveal">
          <div className="dl-bento-map" aria-hidden="true"><span /><span /><span /><span /></div>
          <div className="dl-bento-content"><small>VROOM LIVE</small><h3>Miasto nigdy<br />nie jedzie samo.</h3><p>Spoty, wydarzenia, dyskusje, znajomi i wspólne trasy — społeczność widoczna dokładnie tam, gdzie dzieje się motoryzacja.</p></div>
        </article>
        <article className="dl-bento-card dl-bento-metric dl-reveal"><small>DOSTĘP</small><strong>100%</strong><h3>ZA DARMO</h3><p>Bez opłaty za start. Pobierasz i ruszasz.</p></article>
        <article className="dl-bento-card dl-bento-safety dl-reveal"><span className="material-icons">shield</span><small>LIVE NETWORK</small><h3>BEZPIECZNIEJ<br />NA TRASIE</h3><p>Aktualne ostrzeżenia przekazywane przez kierowców.</p></article>
      </div>
      <div className="dl-social-grid">
        {socialLinks.map((social) => (
          <a className="dl-social-card dl-reveal" href={social.href} key={social.name} target="_blank" rel="noopener noreferrer">
            <span className="material-icons">{social.icon}</span><div><b>{social.name}</b><small>{social.label}</small></div><i>↗</i>
          </a>
        ))}
      </div>
      <div className="dl-support-strip dl-reveal">
        <div><small>NAPĘDZAJ PROJEKT</small><h3>VROOM pozostaje darmowy.</h3><p>Twoje wsparcie utrzymuje serwery i pozwala nam budować kolejne funkcje.</p></div>
        <a className="dl-button dl-button-ghost" href="https://buycoffee.to/vroom" target="_blank" rel="noopener noreferrer">Wesprzyj VROOM <span>↗</span></a>
      </div>
    </section>
  );
}
